import React, { useState } from "react";
import ContentHeader from "../../../Components/ContentHeader/ContentHeader";
import Loading from "../../../Components/Loading/Loading";
import ConfirmModal from "../../../Components/ConfirmModal/ConfirmModal";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import FormModal from "../../../Components/FormModal/FormModal";
import { Formik } from "formik";

function ViewAuditUi({
  data,
  auditData,
  loading,
  auditorName,
  deleteAuditFn,
  imagesAuditData,
  acceptAudits,
  rejectAudits,
  validationSchema,
  setShowForm,
  showForm,
  parsialApprovaAudits,
  ecaAuditData,
  selectedCEN,
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);


  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };
  // const getBadgeColor = (row) => {
  //   switch (status) {
  //     case "completed":
  //       return "bg-completed_theame text-white"; // Green badge for completed
  //       case "approved":
  //         return "bg-approved_theame text-white";
  //     case "In Progress":
  //       return "bg-inprogress_theme text-white"; // Yellow badge for in progress
  //     case "rejected":
  //       return "bg-rejected_theame text-white";
  //     // case "":
  //     //   return ""
  //     default:
  //       return "bg-secondary text-white"; // Default gray badge for other statuses
  //   }
  // };
  const getBadgeColor = (status) => {
    switch (status) {
      case "completed":
        return "bg-completed_theame text-white"; // Green badge for completed
      case "approved":
        return "bg-approved_theame text-white";
      case "In Progress":
        return "bg-inprogress_theme text-white"; // Yellow badge for in progress
      case "rejected":
        return "bg-rejected_theame text-white";
      case "Conditional Approved":
        return "bg-conditional_theame text-white";
      default:
        return "bg-secondary text-white"; // Default gray badge for other statuses
    }
  };
  const status =
    data?.approve_status !== "pending"
      ? data?.approve_status == "partially_approved"
        ? "Conditional Approved"
        : data?.approve_status
      : data?.status;

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}

            <ContentHeader
              title={"Audit Data"}
              buttonName={""}
              buttonBoolean={false}
              pageName={"Audit Data"}
              linkPath={""}
              backButton={true}
            />

            {/* Main content */}
            <section className="content view-audit-container">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <div className="d-flex align-items-center">
                            <h5 className="mb-0">
                              <b>Auditor Name:</b> {auditorName}
                            </h5>
                            <span
                              className={`badge ${getBadgeColor(status)} ml-3`}
                              style={{ padding: "8px 6px" }}
                            >
                              {status?.charAt(0)?.toUpperCase() +
                                status?.slice(1)}
                            </span>
                            {data.partially_approved_count > 0 ?
                            <span className="ml-2">
                            Conditional Approval {data.partially_approved_count} times
                            </span>
                            : null}
                          </div>
                          <div>
                            {(data?.approve_status == "pending" || data?.approve_status == "partially_approved") ? (
                              <>
                                <button
                                  className="btn accepet-btn"
                                  onClick={acceptAudits}
                                  // data-toggle="modal"
                                  // data-target="#modal-danger"
                                >
                                  Approve
                                </button>
                                <button
                                  className="ml-3 btn reject-btn"
                                  onClick={() => setShowForm(true)}
                                  // data-toggle="modal"
                                  // data-target="#modal-danger"
                                >
                                  Reject
                                </button>
                                {data.partially_approved_count < 4 ? (
                                  <button
                                    className="ml-3 btn conditional-btn"
                                    onClick={parsialApprovaAudits}
                                    // data-toggle="modal"
                                    // data-target="#modal-danger"
                                  >
                                    Conditional Approval
                                  </button>
                                ) : null}
                                <button
                                  className="ml-3 btn cancel-btn"
                                  data-toggle="modal"
                                  data-target="#modal-danger"
                                >
                                  Cancel
                                </button>
                              </>
                            ) : null}
                          </div>
                        </div>
                        <table className="mt-4">
                          <tr>
                            <th className="text-center table-heading">
                              CHECK LIST FOR EXAM VENUE AUDIT FOR{" "}
                              {selectedCEN ? selectedCEN?.name : null}
                            </th>
                          </tr>
                        </table>
                        <table>
                          <tr className="font-size-12">
                            <th style={{ width: "2%" }}>Sr</th>

                            <th style={{ width: "40%" }}>
                              Description of Item
                            </th>

                            <th style={{ width: "10%" }}>
                              Reference Para of Tender Document
                            </th>

                            <th style={{ width: "10%" }}>
                              Details submitted by ECA{" "}
                            </th>

                            <th style={{ width: "30%" }}>
                              Remarks / Observations of the RRB
                            </th>
                          </tr>

                          {Object.entries(auditData)?.map((auditTmp, index) => {
                            const [key, value] = auditTmp;
                            
                            return (
                              <>
                               {value?.checkbox_type !== "multiple" && (
  <tr className="font-size-12" key={index}>
    <td style={{ width: "2%" }}>{index + 1}</td>
    <td style={{ width: "40%" }}>
      {value?.question}
    </td>
    <td style={{ width: "10%" }}>
      {value?.reference_para}
    </td>
    {value?.input_type === "dropdown" ? (
      <>
        <td style={{ width: "20%" }}>
          {value?.eca_answer?.length > 0
            ? value?.eca_answer.length
            : "-"}
        </td>
        <td style={{ width: "20%" }}>
          {value?.user_answer?.length > 0
            ? value?.user_answer.length
            : "-"}
        </td>
      </>
    ) : (
      <>
        <td style={{ width: "20%" }}>
          {value?.eca_answer?.length > 0
            ? value?.eca_answer.map((val) => val)
            : "-"}
        </td>
        <td style={{ width: "20%" }}>
          {value?.user_answer?.length > 0
            ? value?.user_answer.map((val) => val)
            : "-"}
        </td>
      </>
    )}
  </tr>
)}

                                {value?.checkbox_type === "multiple" && (
                                  <>
                                    <tr className="font-size-12">
                                      <td style={{ width: "2%" }}>
                                        {index + 1}
                                      </td>

                                      <td style={{ width: "40%" }}>
                                        {value?.question}
                                      </td>

                                      <td style={{ width: "10%" }}>
                                        {value?.reference_para}
                                      </td>
                                      <td style={{ width: "20%" }}>
                                      {value?.eca_answer?.length > 0
                                          ? value?.eca_answer.length
                                          : "-"}
                                      </td>
                                      <td style={{ width: "20%" }}>
                                        {value?.user_answer?.length > 0
                                          ? value?.user_answer.length
                                          : "-"}
                                      </td>
                                    </tr>
                                    {Object.entries(value?.sub_question).map(
                                      ([key, val], ind) => {
                                        return (
                                          <tr className="font-size-12">
                                            <td style={{ width: "2%" }}>
                                              {/* {ind + 1} */}(
                                              {String.fromCharCode(97 + ind)})
                                            </td>

                                            <td style={{ width: "40%" }}>
                                              {val?.question}
                                            </td>

                                            <td style={{ width: "10%" }}>
                                              {val?.reference_para}
                                            </td>
                                            <td style={{ width: "20%" }}>
                                              {val?.eca_answer?.length > 0
                                                ? val?.eca_answer?.map((val) =>
                                                    val == "" ? "-" : val
                                                  )
                                                : "-"}
                                            </td>
                                            <td style={{ width: "20%" }}>
                                              {val?.user_answer?.length > 0
                                                ? val?.user_answer?.map(
                                                    (val) => val
                                                  )
                                                : "-"}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </>
                                )}
                                {/* try */}
                                {value?.input_type === "dropdown" && (
  <>
    {value?.user_answer.map((val, ind) => {
      return (
        <tr className="font-size-12" key={ind}>
          <td style={{ width: "2%" }}>
            ({String.fromCharCode(97 + ind)})
          </td>

          <td style={{ width: "40%" }}>
            {value?.title}
          </td>

          <td style={{ width: "10%" }}>
            {val?.reference_para}
          </td>

          <td style={{ width: "20%" }}>
            {/* Display a single item from eca_answer corresponding to this index */}
            {value?.eca_answer?.[ind] || "-"}
          </td>

          <td style={{ width: "20%" }}>
            {val}
          </td>
        </tr>
      );
    })}
  </>
)}

                                {/* {value?.type === "multiple" && (
                                  <>
                                    <p className="mb-1">
                                      <strong>
                                        ({index}). {value?.label}
                                      </strong>
                                    </p>
                                    {Object.entries(value?.multi_answer).map(
                                      ([key, val], ind) => {
                                        return (
                                          <div key={index} className="ml-3">
                                            <p className="mb-1 ">
                                              <strong>
                                                ({index}.{ind + 1}).{" "}
                                                {val?.label}
                                              </strong>
                                            </p>
                                            {val.answer.includes("files") ? (
                                              <div className="d-flex ">
                                                <p className="mb-1 mr-2">
                                                  <strong>A.</strong>
                                                </p>
                                                <img
                                                  src={`${process.env.REACT_APP_API_ROUTE}${val?.answer}`}
                                                  alt="Answer"
                                                  className="img-fluid"
                                                  style={{
                                                    maxWidth: "50vw",
                                                    height: "500px",
                                                  }}
                                                />
                                              </div>
                                            ) : (
                                              <p className="mb-1">
                                                <strong>A.</strong>{" "}
                                                {val?.answer}
                                              </p>
                                            )}
                                          </div>
                                        );
                                      }
                                    )}
                                  </>
                                )} */}
                              </>
                            );
                          })}
                        </table>
                        <div className="mt-3">
                          <div>
                            <p className="font-size-12 text-center">
                              <b>{imagesAuditData && imagesAuditData?.label}</b>
                            </p>
                          </div>
                          {imagesAuditData && (
                            <div className="img-grid">
                              {Object?.entries(imagesAuditData)?.map(
                                ([key, val], ind) => {
                                  return (
                                    <div>
                                      <p className="mb-1 ">
                                        <strong>{val?.title}</strong>
                                      </p>
                                      {val?.user_answer && (
                                        <img
                                          src={`${process.env.REACT_APP_API_ROUTE}${val?.user_answer[0]}`}
                                          alt="Answer"
                                          className="img-fluid audit-img"
                                          onClick={() =>
                                            handleImageClick(
                                              `${process.env.REACT_APP_API_ROUTE}${val?.user_answer[0]}`
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
      {showForm && (
        <Formik
          initialValues={{
            reason: "",
          }}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values, { resetForm }) => rejectAudits(values, resetForm)}
        >
          {(formik) => (
            <FormModal
              formik={formik}
              handleCloseModal={() => setShowForm(false)}
              title="Add Reason"
            >
              <div className="form-group">
                <label htmlFor="reason">Reason</label>
                <textarea
                  type="text"
                  name="reason"
                  className={`form-control ${
                    formik.errors.reason && formik.touched.reason
                      ? "is-invalid"
                      : ""
                  }`}
                  id="reason"
                  placeholder="Enter Reason"
                  {...formik.getFieldProps("reason")}
                  rows="3"
                ></textarea>
                {formik.errors.reason && formik.touched.reason && (
                  <span className="invalid-feedback">
                    {formik.errors.reason}
                  </span>
                )}
              </div>
            </FormModal>
          )}
        </Formik>
      )}
      <ConfirmModal
        confirmFn={deleteAuditFn}
        text={"Are you sure,You want to Cancel Audit  ?"}
        buttonText={"Delete"}
      />
      {/* Modal for Image Preview */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Preview"
              className="modal-img w-100"
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ViewAuditUi;
